import { MANAGED_AGENT_TYPE } from "../helpers/constants"
import { Thread } from "../types/thread"

// Both chat surfaces share one ThreadsProvider and one threads query; this splits the fetched list by
// surface. The managed agent-chat page shows only managed threads; the legacy drawer shows everything
// that is not managed (legacy threads carry no agentType, so the negative test also covers null).
export function filterThreadsByAgentType(threads: readonly Thread[], isManagedAgent: boolean): Thread[] {
  return threads.filter((thread) =>
    isManagedAgent ? thread.agentType === MANAGED_AGENT_TYPE : thread.agentType !== MANAGED_AGENT_TYPE,
  )
}
